export var LoanStatus;
(function (LoanStatus) {
    LoanStatus["ACTIVE"] = "ACTIVE";
    LoanStatus["COVERED"] = "COVERED";
    LoanStatus["LIQUIDATED"] = "LIQUIDATED";
    LoanStatus["PENDING"] = "PENDING";
})(LoanStatus || (LoanStatus = {}));
export var LoanHealthStatus;
(function (LoanHealthStatus) {
    LoanHealthStatus["CRITICAL"] = "CRITICAL";
    LoanHealthStatus["NEUTRAL"] = "NEUTRAL";
    LoanHealthStatus["HEALTHY"] = "HEALTHY";
})(LoanHealthStatus || (LoanHealthStatus = {}));
//# sourceMappingURL=loan.js.map